import { user } from "../auth/user";
import {getUserManager} from '../auth/auth';
import {getAppConfig} from "../helpers/app-config.helper";
import type {HttpMethod} from "../types/requests/http-method.type";

let c;

user.subscribe((value) => {
    c = value;
});

async function getAccessToken() {
    const userManager = getUserManager();
    const user = await userManager.getUser();

    if (!user || user.expired) {
        const refreshed = await userManager.signinSilent();
        return refreshed.access_token;
    }

    return user.access_token;
}

export async function makeApiCall(endpoint: string, method: HttpMethod = 'GET', content?: unknown) {
    const response = await callEndpointBase(endpoint, method, content)
    const responseAsText = await response.text();
    const responseAsJson = responseAsText ? JSON.parse(responseAsText) : null;
    
    return responseAsJson?.value ? responseAsJson?.value : responseAsJson;
}

export async function fetchFile(endpoint: string): Promise<Blob> {
    const response = await callEndpointBase(endpoint, 'GET');
    
    return await response.blob();
}

async function callEndpointBase(endpoint: string, method: HttpMethod = 'GET', content?: unknown): Promise<Response> {
    const accessToken = await getAccessToken();
    const baseUrl = getAppConfig().apiUrl;

    const response = await fetch(`${baseUrl}/${endpoint}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        method: method,
        body: content ? JSON.stringify(content) : undefined
    });

    if (!response)
        return;

    if (response.status !== 200)
        throw new Error(`Error ${response.status} occurred while making an API call to ${name}: ${response.statusText} `);

    if (!response.ok)
        throw new Error(`HTTP ${response.status}`);

    return response;
}